import { useState, useEffect, memo } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ExternalLink, Search } from "lucide-react";
import axios from "axios";
import { API } from "../lib/api";

const GoogleTrends = () => {
  const [trends, setTrends] = useState([]);

  useEffect(() => {
    axios.get(`${API}/google-trends`).then(r => setTrends(r.data || [])).catch(() => {});
  }, []);

  if (trends.length === 0) return null;

  return (
    <div className="mb-6 lg:mb-10" data-testid="google-trends">
      <div className="flex items-center gap-2 mb-3 lg:mb-5">
        <div className="p-1.5 bg-red-500/10 rounded-lg">
          <Search className="w-4 h-4 lg:w-5 lg:h-5 text-red-400" />
        </div>
        <h2 className="text-base lg:text-xl font-bold text-white">Türkiye'de Trend</h2>
        <span className="text-[10px] lg:text-xs text-red-400 bg-red-500/10 px-2 py-0.5 rounded-full">Google</span>
      </div>

      {/* Mobile: Horizontal Scroll */}
      <div className="lg:hidden -mx-4 px-4">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-2 snap-x">
          {trends.slice(0, 10).map((t, i) => (
            <div 
              key={i} 
              className="flex-shrink-0 flex items-center gap-2 px-3 py-2 bg-zinc-900/50 border border-zinc-800/50 rounded-full snap-start"
              data-testid={`gtrend-mobile-${i}`}
            >
              <span className="w-5 h-5 bg-red-500/20 text-red-400 rounded-full flex items-center justify-center text-[10px] font-bold">{i + 1}</span>
              <span className="text-xs text-white whitespace-nowrap">{t.keyword}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop: Grid */}
      <div className="hidden lg:grid grid-cols-2 md:grid-cols-5 gap-2">
        {trends.slice(0, 10).map((t, i) => (
          <div key={i} className="group bg-zinc-900/50 border border-zinc-800/50 hover:border-red-500/30 rounded-xl p-3 transition-all" data-testid={`gtrend-${i}`}>
            <div className="flex items-start gap-2 mb-2">
              <span className="flex-shrink-0 w-6 h-6 bg-red-500/20 text-red-400 rounded-lg flex items-center justify-center text-xs font-bold">{i + 1}</span>
              <h3 className="text-sm font-semibold text-white group-hover:text-red-300 transition-colors line-clamp-2 leading-snug">{t.keyword}</h3>
            </div>
            {t.traffic && <p className="text-[10px] text-zinc-500">{t.traffic} arama</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(GoogleTrends);
